import { axiosGet, axiosPost } from "./axiosFunctions";
import { getAuthState } from "../../assets/scripts/login-util";

const getClientsUrl         = '/api/doctor/dashboard/getClients';
const getClientDetailsUrl   = '/api/doctor/dashboard/getClientDetails';
const addCommentUrl         = '/api/doctor/dashboard/addComment';
const deleteCommentUrl      = '/api/doctor/dashboard/deleteComment';

export const getClientList = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet( getClientsUrl, { headers: { auth_token: `bearer ${token}` }} );
    return response;
}

export const getClientDetails = async (clientId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        getClientDetailsUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { clientId }} 
    );
    return response;
};

export const addComment = async (comment) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosPost(
        addCommentUrl,
        { comment },
        { headers: { auth_token: `bearer ${token}` }} 
    );
    return response;
};

export const deleteComment = async (id) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return window.open('/', '_self'); }, 2000);
    
    const response = await axiosGet(   
        deleteCommentUrl,        
        { headers: { auth_token: `bearer ${token}`},  params: { id }} 
    );
    return response;
};